import { render } from "./PaymentManual.vue?vue&type=template&id=178ce970&ts=true"
import script from "./PaymentManual.vue?vue&type=script&lang=ts"
export * from "./PaymentManual.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__